// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import rpointEntity from './entities/rpoint.json';
import rpointMenu from '../pages/rpoint/menu.json';
import rpointFullForm from '../pages/rpoint/forms/full.json';
import rpointContextForm from '../pages/rpoint/forms/context.json';
import rpointMiniForm from '../pages/rpoint/forms/mini.json';
import rpointLookupForm from '../pages/rpoint/forms/lookup.json';
import rpointTableView from '../pages/rpoint/views/table.json';
import rpointStagesView from '../pages/rpoint/views/stages.json';
import rpointCardsView from '../pages/rpoint/views/cards.json';
import rpointInlineView from '../pages/rpoint/views/inline.json';
import rpointBacklogView from '../pages/rpoint/views/backlog.json';
import rpointSplitView from '../pages/rpoint/views/split.json';
import rpointCalendarView from '../pages/rpoint/views/calendar.json';
import rpointDashboardView from '../pages/rpoint/views/dashboard.json';

/** Тип запису «Приймальня депутата» зі сторінками пакета: меню, форми та подання з pages/rpoint/. */
export const rpointDefinition: IRecordTypeDefinition = {
  ...rpointEntity,
  views: assembleViewSet({
      table: rpointTableView,
      stages: rpointStagesView,
      cards: rpointCardsView,
      inline: rpointInlineView,
      backlog: rpointBacklogView,
      split: rpointSplitView,
      calendar: rpointCalendarView,
      dashboard: rpointDashboardView,
  }),
  form: rpointFullForm,
  forms: { full: rpointFullForm, context: rpointContextForm, mini: rpointMiniForm, lookup: rpointLookupForm },
  menu: rpointMenu,
} as IRecordTypeDefinition;
